<template>
  <!-- import styles if needed -->
  <PageLoader class="mb-5 mt-5" v-if="isLoading"></PageLoader>
  <div v-if="is_loaded" v-show="!isLoading">
    <!-- import styles if needed -->

    <div v-if="is_loaded">
      <div id="current-user-wrapper">
        <snipp-current-user :campaign-id="campaignId" :user-status="user_status" @show-registration="showRegistration"
          @snipp-logout="handleSnippLogout" @show-confirmation="showConfirmation" @current-user="handleCurrentUser"
          custom-css="https://snippcheck.blob.core.windows.net/files/ArmHammer_2008526_CatLitterRebate/custom_overrides.css"
          :language="$t('Language')"></snipp-current-user>
      </div>
      <div id="registration-wrapper" v-if="registration_enabled" ref="registrationSection">
        <div v-if="isIneligible">
          <h1 class="mb-3">You Are Not Eligible To Participate In This Program</h1>
          <p>Please refer to the program <a rel="noopener noreferrer" href="https://snipp.us/!cuYTg"
              target="_blank">Terms &amp; Conditions</a> for more details.</p>
        </div>
        <snipp-registration app-source="CampaignWidget" refresh-reload="true" :campaign-id="campaignId"
          :show-confirmation="show_confirmation"
          custom-css="https://snippcheck.blob.core.windows.net/files/ArmHammer_2008526_CatLitterRebate/custom_overrides.css"
          :is-logged-out="is_logged_out" @is-registered="handleIsRegistered" @snipp-widget-event="handleGateWidgetEvent"
          :language="$t('Language')"></snipp-registration>
      </div>
      <div id="thanks-text" v-if="upload_enabled === 'upload_again'" ref="thanksSection">
        <br />
        <h1 class="mb-3">{{ $t('IPEwidget.ThanksTitle') }} </h1>
        <p v-html="$t('IPEwidget.ThanksDesc')">
        </p>
        <p v-html="$t('IPEwidget.TermsLink')" class="d-none"></p>
        <br />
      </div>
      <div id="upload-wrapper" v-if="upload_enabled" ref="uploadSection">
        <div id="upload-original" v-if="upload_enabled !== 'upload_again'">
          <div class="hide-dlr">
            <h2 class="text-center my-4">{{ $t('IPEwidget.UploadReceiptTitle') }}</h2>
          </div>
          <div class="show-dlr" style="display: none;">
            <h2 class="text-center my-4">{{ $t('IPEwidget.DLRTitle') }}</h2>
          </div>
          <div v-html="$t('IPEwidget.ImageUploadDesc1')" class="mt-4 mb-0 hide-dlr"></div>
          <snipp-upload :campaign-id="campaignId" include-upload-button="true"
            @snipp-upload-result="handleSnippUploadResult" @snipp-widget-event="handleSnippWidgetEvent"
            custom-css="https://snippcheck.blob.core.windows.net/files/ArmHammer_2008526_CatLitterRebate/custom_overrides.css"
            :language="$t('Language')"></snipp-upload>
          <div class="my-5 text-center hide-dlr">
            <p v-html="$t('IPEwidget.PP')" class="fw-bold mb-2"></p>
            <p><small v-html="$t('Home.ParticipatingProductLink')" @click="handleLinkClick"></small></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageLoader from '../../../components/UI/PageLoader.vue';
export default {
  components: { PageLoader },
  props: ['campaignId'],
  emits: [],
  data() {
    return {
      ts: Date.now(),
      isLoading: true,
      is_loaded: false,
      is_logged_out: undefined,
      upload_enabled: undefined,
      registration_enabled: false,
      show_confirmation: undefined,
      user_status: undefined,
      uploadLimitReached: false,
      showDlr: false,
      isIneligible: false,
    };
  },
  methods: {
    showRegistration(confirmation) {
      if (this.upload_enabled) this.upload_enabled = undefined;
      if (confirmation) {
        this.show_confirmation = true;
      } else {
        this.show_confirmation = undefined;
      }
      this.registration_enabled = true;
      this.$nextTick(() => {
        this.$refs.registrationSection?.scrollIntoView({ behavior: 'smooth' });
      });
    },
    showConfirmation() {
      this.showRegistration(true);
    },
    handleSnippLogout() {
      this.upload_enabled = undefined;
      this.is_logged_out = true;
      this.showRegistration();
    },
    handleIsRegistered() {
      this.user_status = Date.now();
      this.upload_enabled = 'upload';
      this.registration_enabled = false;
      this.$nextTick(() => {
        this.$refs.uploadSection?.scrollIntoView({ behavior: 'smooth' });
      });
    },
    handleSnippUploadResult() {
      this.upload_enabled = 'upload_again';
      this.$nextTick(() => {
        this.$refs.thanksSection?.scrollIntoView({ behavior: 'smooth' });
      });
    },
    handleSnippWidgetEvent(e) {
      // check inside event
      if (e && e.detail && e.detail.length) {
        let message = e.detail[0];
        this.uploadLimitReached = true;
        const elements2 = document.querySelectorAll('.show-dlr');
        if (message.upload_limit_reached) {
          // ... TODO: some cool reactive handling to update your UI here ...
          this.showDlr = true;
          const elements = document.querySelectorAll('.hide-dlr');
          elements.forEach(el => {
            el.style.display = 'none';
          });

          elements2.forEach(el => {
            el.style.display = 'block';
          });
        }
        else {
          elements2.forEach(el => {
            el.style.display = 'none';
          });
        }
      }

    },
    handleCurrentUser() {
      this.registration_enabled = false;
      this.upload_enabled = 'upload';
    },
    handleLinkClick(event) {
      const target = event.target.closest('a');
      if (target) {
        const href = target.getAttribute('href');

        // Only intercept internal links (those starting with '/')
        if (href && href.startsWith('/')) {
          event.preventDefault();
          this.$router.push(href);
        }
      }
    },
    handleGateWidgetEvent(e) {
      if (e && e.detail && e.detail.length) {
        let message = e.detail[0];
        if (message.gate_ineligible || message.ineligible) {
          this.isIneligible = true;
        }
      }
    },
    observeGateIneligible() {
      const getShadowRoot = () => document.querySelector('snipp-registration')?.shadowRoot;

      const check = () => {
        const shadowRoot = getShadowRoot();
        if (!shadowRoot) return;

        const ineligible = shadowRoot.querySelector('.snipp-gate-ineligible');
        if (!ineligible) return;

        const isIneligible = ineligible.style.display !== 'none';
        const ageGate = shadowRoot.querySelector('.snipp-age-gate');
        const stateGate = shadowRoot.querySelector('.snipp-state-gate');

        if (isIneligible) {
          this.isIneligible = true;
          if (ageGate) ageGate.style.display = 'none';
          if (stateGate) stateGate.style.display = 'none';
          const gateTitle = shadowRoot.querySelector('.snipp-gate-title');
          if (gateTitle) gateTitle.style.display = 'none';
          const gateWrapper = shadowRoot.querySelector('.snipp-gate-wrapper');
          if (gateWrapper) gateWrapper.style.display = 'none';
        }
      };

      let elapsed = 0;
      this._gateInterval = setInterval(() => {
        check();
        elapsed += 500;
        if (elapsed >= 30000) clearInterval(this._gateInterval);
      }, 500);
    },
  },
  mounted() {
    this.is_loaded = true;
    setTimeout(() => (this.isLoading = false), 1500);
    this.observeGateIneligible();
  },
  beforeUnmount() {
    clearInterval(this._gateInterval);
  },
};
</script>
<style v-if="isIneligible">
.snipp-age-gate,
.snipp-state-gate {
  display: none !important;
}
</style>
<style scoped>
.wrapper {
  margin-top: 57px;
}

.color-red {
  color: #bf233a;
}

#current-user-wrapper,
#upload-wrapper {
  max-width: 70%;
  margin: 0 auto
}

@media screen and (max-width: 575px) {

  #current-user-wrapper,
  #upload-wrapper {
    max-width: 100%;
    margin: 0 auto
  }
}
</style>
